import { createSelector } from 'reselect';

const selectTenantOpennetworkCategories = (state: any) => state.tenantOpenNetworkCategories;


export const selectTenantOpennetworkCategoriesCurrentItem = createSelector([selectTenantOpennetworkCategories], (tenantOpenNetworkCategories) => tenantOpenNetworkCategories.current);

export const selectTenantOpennetworkCategoriesListItems = createSelector([selectTenantOpennetworkCategories], (tenantOpenNetworkCategories) => tenantOpenNetworkCategories.list);

export const selectTenantOpennetworkCategoriesItemById = (itemId: any) =>
    createSelector(selectTenantOpennetworkCategoriesListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectOpennetworkCategoryCreatedItem = createSelector([selectTenantOpennetworkCategories], (tenantOpenNetworkCategories) => tenantOpenNetworkCategories.create);

export const selectOpennetworkCategoryQueryItems = createSelector([selectTenantOpennetworkCategories], (tenantOpenNetworkCategories) => tenantOpenNetworkCategories.query);

export const selectOpennetworkCategoryUpdatedItem = createSelector([selectTenantOpennetworkCategories], (tenantOpenNetworkCategories) => tenantOpenNetworkCategories.update);

export const selectOpennetworkCategoryReadItem = createSelector([selectTenantOpennetworkCategories], (tenantOpenNetworkCategories) => tenantOpenNetworkCategories.read);

export const selectOpennetworkCategoryDeletedItem = createSelector([selectTenantOpennetworkCategories], (tenantOpenNetworkCategories) => tenantOpenNetworkCategories.delete);

export const selectOpennetworkCategorySearchedItems = createSelector([selectTenantOpennetworkCategories], (tenantOpenNetworkCategories) => tenantOpenNetworkCategories.search);

export const selectOpennetworkCategoryItemsCount = createSelector([selectTenantOpennetworkCategories], (tenantOpenNetworkCategories) => tenantOpenNetworkCategories.count);

export const selectOpennetworkCategoryItemsFilter = createSelector([selectTenantOpennetworkCategories], (tenantOpenNetworkCategories) => tenantOpenNetworkCategories.filter);